module.exports = __webpack_public_path__ + "static/img/cMRIp4.5e805e73.png";